import request from "@/untils/request.js"

export const getOnCreditPage = (params) => {
    return request.get("/outpatient/bebtrecord/page", {params})
}


export const getOneOnCreditById = (id) => {
    return request.get(`/outpatient/bebtrecord/${id}`)
}

export const onCreditRepayment = (params) => {
    return request.get('/outpatient/bebtrecord/charge', {params})
}